// Navbar2.jsx — Floating Controls Edition (2026)
// ناوبر بالا حذف شده — فقط دو دکمه شناور (منو + سکه) + دراور
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar2.css";
import { useCoins } from "../context/CoinContext";
import { useAuth } from "../context/AuthContext";
import React, { useState, useEffect } from "react";
import { engine } from "../core/books/storage.js";
import UserProfileModal from "../team/UserProfileModal.jsx";

const DEFAULT_AVATAR = "/avatars/avatar34.png";

// ============================================================
// 📋 آیتم‌های منو + نقش‌هایی که هر آیتم را می‌بینند
// ============================================================
const MENU_ITEMS = [
  {
    id: "app-versions",
    icon: "fas fa-cloud-upload-alt",
    label: "مدیریت به‌روزرسانی",
    path: "/admin/app-versions",
    dividerBefore: true,
    roles: ["admin"],
  },
    {
    id: "teacher-shelf",
    icon: "fas fa-star",
    label: "اساتید برگزیده",
    path: "/admin/teacher-shelf",
    badge: "جدید",
    roles: ["admin"],
  },
  {
    id: "medals",
    icon: "fas fa-medal",
    label: "لیگ ها",
    path: "/medals",
    badge: "0",
    roles: ["student", "parent", "admin"],
  },
  {
    id: "challenge",
    icon: "fas fa-fire",
    label: "چالش ها",
    path: "/Challenge",
    roles: ["student", "admin"],
  },
  {
    id: "lesson-planning",
    icon: "fas fa-clipboard-list",
    label: "برنامه درسی",
    path: "/Lesson-planning",
    roles: ["student", "admin"],
  },
  {
    id: "lesson-planning-teacher",
    icon: "fas fa-clipboard-list",
    label: "ساخت برنامه درسی",
    path: "/Lesson-planning",
    roles: ["teacher"],
  },
  {
    id: "study-timer",
    icon: "fas fa-stopwatch",
    label: "اتاق مطالعه",
    path: "/StudyTimer",
    roles: ["student", "parent", "admin"],
  },
  {
    id: "games",
    icon: "fas fa-gamepad",
    label: "بازی‌ها",
    path: "/games",
    badge: "جدید",
    roles: ["student"],
  },
  {
    id: "parent-dashboard",
    icon: "fas fa-chart-line",
    label: "گزارش پیشرفت",
    path: "/parent-dashboard",
    dividerBefore: true,
    roles: ["student", "parent", "admin"],
  },
  {
    id: "weather",
    icon: "fas fa-cloud-sun",
    label: "آب و هوا",
    path: "/WeatherPage",
    badge: "جدید",
    roles: ["teacher", "parent", "admin"],
  },
  {
    id: "ConvertPage",
    icon: "fas fa-file-export",
    label: "تبدیل word به pdf",
    path: "/ConvertPage",
    badge: "جدید",
    roles: ["teacher", "parent", "admin"],
  },
];

// ============================================================
// Helper: تبدیل عدد به فارسی
// ============================================================
const toFaNum = (n) => {
  if (n === undefined || n === null) return "۰";
  return String(n).replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
};

export default function Navbar2({ openSettings }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { coins, xp } = useCoins();
  const { user, logout } = useAuth();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [isDarkDrawer, setIsDarkDrawer] = useState(() => {
    try {
      return engine.getRaw("navbar2-drawer-dark") === "1";
    } catch {
      return false;
    }
  });

  const [showProfileModal, setShowProfileModal] = useState(false);

  // ─── آواتار کاربر ───
  const userAvatar =
    (user?.avatar && String(user.avatar).trim()) || DEFAULT_AVATAR;

  // ─── سطح کاربر ───
  const getLevel = (xpVal) => Math.floor((xpVal || 0) / 100) + 1;

  // ─── استریک (روزهای پیاپی) ───
  const getStreak = () => {
    if (!user?.id) return 0;
    try {
      const data = engine.get(`streak-${user.id}`, null);
      if (!data || typeof data !== "object") return 0;
      const today = new Date().toISOString().split("T")[0];
      const yesterday = new Date(Date.now() - 86400000)
        .toISOString()
        .split("T")[0];
      const last = data.lastActivityDate || data.lastDate;
      if (last === today || last === yesterday) {
        return Number(data.streak) || 0;
      }
      return 0;
    } catch {
      return 0;
    }
  };

  const userLevel = getLevel(xp);
  const streak = getStreak();

  // ─── نام کاربر ───
  const fullName = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim() ||
      user.username ||
      "کاربر"
    : "کاربر";

  const userContact = user?.phone || user?.username || "";

  // ─── نقش و آیتم‌های قابل نمایش ───
  const userRole = user?.role || "student";
  const visibleMenuItems = MENU_ITEMS.filter((item) =>
    item.roles.includes(userRole)
  );

  // ─── توابع دراور ───
  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => {
      const next = !prev;
      document.body.style.overflow = next ? "hidden" : "";
      return next;
    });
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    document.body.style.overflow = "";
  };

  // بستن دراور هنگام تغییر مسیر
  useEffect(() => {
    closeDrawer();
    
  }, [location.pathname]);

  // ذخیره تم در engine
  useEffect(() => {
    try {
      engine.setRaw("navbar2-drawer-dark", isDarkDrawer ? "1" : "0");
    } catch {}
  }, [isDarkDrawer]);

  // اگر در صفحه مدال‌ها هستیم → نمایش داده نشود
  if (location.pathname === "/medals") {
    return null;
  }

  // ─── انیمیشن کلیک روی سکه ───
  const handleCoinClick = (e) => {
    const btn = e.currentTarget;
    btn.style.transform = "scale(0.94)";
    setTimeout(() => {
      btn.style.transform = "";
    }, 180);
    navigate("/coins");
  };

  // ─── انیمیشن کلیک روی آیتم‌های دراور ───
  const handleDrawerItemClick = (callback) => {
    return (e) => {
      const item = e.currentTarget;
      item.style.transform = "scale(0.95)";
      setTimeout(() => {
        item.style.transform = "";
      }, 200);

      if (callback) callback();
      closeDrawer();
    };
  };

  // ─── خروج ───
  const handleLogout = () => {
    logout();
    navigate("/login");
    closeDrawer();
  };

  return (
    <div className={`navbar2-wrapper ${isDarkDrawer ? "dark-mode" : ""}`}>
      {/* ============================================================
          FLOATING CONTROLS (جایگزین ناوبر بالا)
          ============================================================ */}
      <div className="float-controls">
        {/* دکمه منو — سمت راست */}
        <button
          className="float-btn float-menu"
          onClick={toggleDrawer}
          aria-label="منو"
          aria-expanded={isDrawerOpen}
        >
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span className="dot" aria-hidden="true"></span>
        </button>

        {/* دکمه سکه — سمت چپ */}
        <button
          className="float-btn float-coins"
          onClick={handleCoinClick}
          aria-label="کیف پول"
        >
          <i className="fas fa-coins"></i>
          <span className="amount">{toFaNum(coins || 0)}</span>
        </button>
      </div>

      {/* ============================================================
          DRAWER
          ============================================================ */}
      <div
        className={`drawer-overlay ${isDrawerOpen ? "open" : ""}`}
        onClick={closeDrawer}
        aria-hidden="true"
      ></div>

      <aside
        className={`drawer ${isDrawerOpen ? "open" : ""}`}
        aria-hidden={!isDrawerOpen}
      >
        {/* هدر دراور */}
        <div className="drawer-header">
          <div className="drawer-avatar">
            <img
              src={userAvatar}
              alt="avatar"
              onError={(e) => {
                if (!e.currentTarget.dataset.fallback) {
                  e.currentTarget.dataset.fallback = "1";
                  e.currentTarget.src = DEFAULT_AVATAR;
                }
              }}
            />
          </div>
          <div className="drawer-user">
            <div className="name">{fullName}</div>
            <div className="role">
              {userLevel > 0 && `سطح ${toFaNum(userLevel)}`}
              {userLevel > 0 && streak > 0 && ` · ${toFaNum(streak)} روز پیاپی`}
            </div>
            {userContact && <div className="email">{userContact}</div>}
          </div>
          <button
            className="drawer-close"
            onClick={closeDrawer}
            aria-label="بستن"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* ═══ مشاهده پروفایل ═══ */}
        <div
          className="drawer-item"
          onClick={handleDrawerItemClick(() => setShowProfileModal(true))}
        >
          <i className="fas fa-user-circle"></i>
          <span>مشاهده پروفایل</span>
        </div>

        {/* ═══ آواتارهای من ═══ */}
        <div
          className="drawer-item"
          onClick={handleDrawerItemClick(() => navigate("/avatars"))}
        >
          <i className="fas fa-user-astronaut"></i>
          <span>آواتارهای من</span>
        </div>

        {/* آیتم‌های منو بر اساس نقش */}
        {visibleMenuItems.map((item) => (
          <React.Fragment key={item.id}>
            {item.dividerBefore && <div className="drawer-divider" />}
            <div
              className="drawer-item"
              onClick={handleDrawerItemClick(() => navigate(item.path))}
            >
              <i className={item.icon}></i>
              <span>{item.label}</span>
              {item.badge && (
                <span className="drawer-badge">{item.badge}</span>
              )}
            </div>
          </React.Fragment>
        ))}

        <div className="drawer-divider"></div>

        {/* تم تاریک/روشن */}
        <div
          className="drawer-item"
          onClick={() => setIsDarkDrawer(!isDarkDrawer)}
        >
          <i className={`fas ${isDarkDrawer ? "fa-sun" : "fa-moon"}`}></i>
          <span>{isDarkDrawer ? "حالت روشن" : "حالت تیره"}</span>
        </div>

        {/* تنظیمات */}
        <div
          className="drawer-item"
          onClick={handleDrawerItemClick(() => openSettings?.())}
        >
          <i className="fas fa-cog"></i>
          <span>تنظیمات</span>
        </div>

        <div className="drawer-divider"></div>

        {/* خروج */}
        <div
          className="drawer-item danger"
          onClick={handleDrawerItemClick(handleLogout)}
        >
          <i className="fas fa-sign-out-alt"></i>
          <span>خروج</span>
        </div>
      </aside>

      {showProfileModal && (
        <UserProfileModal
          userId={user?.id}
          onClose={() => setShowProfileModal(false)}
          presenceMap={{}}
          isDarkMode={isDarkDrawer}
        />
      )}
    </div>
  );
}